export default __webpack_public_path__ + "vqa3c9ab6.png";